import { z } from 'zod';

export const createChallengeSchema = z
  .object({
    title: z.string().min(1).max(200),
    description: z.string().max(1000).default(''),
    metric: z.enum(['HOURS_LOGGED', 'TASKS_COMPLETED']),
    targetValue: z.number().int().positive(),
    startsAt: z.string().datetime(),
    endsAt: z.string().datetime(),
    bonusPoints: z.number().int().min(0).default(0),
  })
  .refine((v: { startsAt: string; endsAt: string }) => new Date(v.endsAt) > new Date(v.startsAt), {
    message: 'endsAt must be after startsAt',
    path: ['endsAt'],
  });
export type CreateChallengeInput = z.infer<typeof createChallengeSchema>;

export const leaderboardQuerySchema = z.object({
  period: z.enum(['week', 'month', 'all_time']).default('all_time'),
});
export type LeaderboardQuery = z.infer<typeof leaderboardQuerySchema>;
